import { render, staticRenderFns } from "./projectdict.vue?vue&type=template&id=2d9ac76b&"
import script from "./projectdict.vue?vue&type=script&lang=js&"
export * from "./projectdict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports